import React, {useMemo} from "react";
import SkeletonRectangle from "../../skeletons/SkeletonRectangle";

export default function AsyncTableLoader({
    limit,
    allItems,
    page,
    headersCount,
}) {
    const rowsToRender = useMemo(() => {
        const startIndex = (page - 1) * limit + 1;
        const endIndex = Math.min(page * limit, allItems);
        if (startIndex > allItems) return limit; // najczesciej na pierwszym ladowaniu, wiec oczekujemy maxa
        return endIndex - startIndex + 1;
    }, [page, limit, allItems]);

    return (
        <tbody>
            {new Array(rowsToRender).fill(0).map((_, i) => (
                // osobny prostokąt w każdej komórce - szkielet odzwierciedla kolumny tabeli
                <tr key={i} className="loader">
                    {new Array(headersCount).fill(0).map((_, cell) => (
                        <td key={cell}>
                            &nbsp;
                            <SkeletonRectangle />
                        </td>
                    ))}
                </tr>
            ))}
        </tbody>
    );
}
